module.exports = __webpack_public_path__ + "static/media/DesarrolloFrontEndServerlessBadge.e56d1862.png";